import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LoginForm } from '../Auth/LoginForm';
import './LoginPage.css';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, isLoading } = useAuth();

  useEffect(() => {
    // Aguardar o carregamento da autenticação
    if (isLoading) return;

    // Se já estiver autenticado como admin, redirecionar para o painel
    if (isAuthenticated && user?.role === 'admin') {
      navigate('/admin');
    } else if (isAuthenticated && user?.role !== 'admin') {
      // Se estiver autenticado mas não for admin, redirecionar para home
      navigate('/');
    }
  }, [isAuthenticated, user?.role, navigate, isLoading]);

  const handleLoginSuccess = () => {
    // O redirecionamento será feito pelo useEffect quando isAuthenticated for atualizado
  };

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="loading-spinner"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  // Mostrar formulário apenas se não estiver autenticado ou não for admin
  if (!isAuthenticated || user?.role !== 'admin') {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-form-container">
            <LoginForm onSuccess={handleLoginSuccess} />
          </div>
          <div className="login-footer">
            <a href="/" className="back-link">← Voltar para o site</a>
          </div>
        </div>
      </div>
    );
  }

  // Se chegar aqui e estiver autenticado como admin, mostrar loading enquanto redireciona
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="loading-spinner"></div>
        <p>Redirecionando...</p>
      </div>
    </div>
  );
};

